import React, { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useTranslation } from "react-i18next";

export default function CheckoutForm({ onPaymentSuccess, successMessage, creditCardDetails, setcreditCardDetails, amount }) {
    console.log('4')
    const stripe = useStripe();
    const elements = useElements();
    const [message, setMessage] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation();
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
    const [paymentError, setPaymentError] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form submission default behavior

        if (!stripe || !elements) {
            return;
        }

        // Confirm the payment
        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            redirect: 'if_required', // Handle 3D Secure authentication if required
            payment_method: {
                billing_details: {
                    name: "XXXX", // Pass customer name
                    address: {
                        line1: "Gis System", // Pass customer address
                    }
                }
            }
        });

        if (error) {
            setMessage(error.message);
            setPaymentError(true);
            setIsModalOpen(true);
            setcreditCardDetails((state) => ({
                ...state,
                message: error.message,
                payment: false,
            }));
        } else if (paymentIntent.status === 'succeeded') {
            console.log(paymentIntent,"paymentIntent")
            setMessage(successMessage);
            setIsModalOpen(true);
            setPaymentError(false);
            // onPaymentSuccess();
            setcreditCardDetails((state) => ({
                ...state,
                payment: true,
                message: successMessage,
                stripekey: paymentIntent?.id,
                transID:paymentIntent?.id
            }));
        }
    };

    return (
        <div>
            {!creditCardDetails?.payment && (
                <>
                    <PaymentElement id="payment-element" />
                    <button onClick={handleSubmit} className="main-body-row-right-col-inner-payment-tabs-card-single-detail-payment-btn">
                        Pay
                    </button>
                </>
            )}

            {/* Show error or success messages */}
            {message && (
                <>
                    {/* QR Code Modal */}
                    {isModalOpen && (
                        <div className="modal-overlay">
                            <div className="main-body-row-right-col-inner-payment-tabs-card-bank-btn-row-QrcodeModel">

                                {!paymentError ? (
                                    <>
                                        <p className="QrcodeModel-heading">{t("Payment Status")}</p>
                                        <img src={base_assets + "images/pos/icons/check-success.png"} alt="Payment Code" />
                                        <p>{t("Amount")}: {amount}</p>
                                        <p>{message}</p>
                                        <button
                                            className="QrcodeModel-cancel-btn"
                                            onClick={() => {
                                                setIsModalOpen(false);
                                                onPaymentSuccess();
                                            }}
                                        >
                                            {t("Continue")}
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <p className="QrcodeModel-heading">{t("Payment Failed")}</p>
                                        <img src={base_assets + "images/pos/icons/check-cancel.webp"} alt="Payment Code" />
                                        <p>{message}</p>
                                        <button
                                            className="QrcodeModel-cancel-btn"
                                            onClick={() => {
                                                setIsModalOpen(false);
                                            }}
                                        >
                                            {t("Closed")}
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
